import React from "react";
import ReactDOM from "react-dom";
import "./i18n";
import "./index.scss";
import "react-day-picker/lib/style.css";
import "./shared/styles/themeColors.scss";
import "react-toastify/dist/ReactToastify.css";
import Root from "./app/components/Root";

/** Si la cookie trae una sesión viva, a dónde entra esa persona. Si no, null. */
const targetForActiveSession = (omuniWeb) => {
  try {
    const match = document.cookie.match(/(?:^|;\s*)session=([^;]*)/);
    if (!match) return null;
    const session = JSON.parse(decodeURIComponent(match[1]));
    if (!session?.accessToken || !session?.refreshToken) return null;
    const payload = JSON.parse(atob(session.refreshToken.split(".")[1]));
    if (payload.exp * 1000 < Date.now()) return null;
    const preferredHome = localStorage.getItem('omuni_preferred_home');
    const isDashboard = !preferredHome || preferredHome.toLowerCase() === 'dashboard';
    return isDashboard ? '/home' : `${omuniWeb}/${preferredHome}`;
  } catch {
    return null;
  }
};

const preRenderRedirect = () => {
  const p = window.location.pathname;
  const shouldRedirect =
    p === "/" ||
    p === "/old" ||
    p === "/old/" ||
    p.startsWith("/old/signin");
  if (!shouldRedirect) return false;

  const omuniWeb = process.env.REACT_APP_OMUNI_WEB;
  if (!omuniWeb) return false;

  const target = targetForActiveSession(omuniWeb);
  if (target) {
    window.location.replace(target);
    return true;
  }

  // Sin sesión, el acceso es el de omuni-web: esta pantalla ya no se muestra.
  //
  // Dos cosas quedan afuera del rebote a propósito. Las subrutas de /signin,
  // porque de ahí cuelga el recupero de contraseña, que sigue viviendo solo
  // acá. Y ?error=auth, que es a donde el proveedor de identidad devuelve al
  // usuario cuando falla el ingreso por OpenID: esa URL se la pasamos al back
  // en el POST /v2/login/{provider} (ver FormLogin, handleOpenIdLogin), así
  // que sale del sistema, y rebotarla perdería el motivo del fallo.
  const isLoginScreen = p === "/old/signin" || p === "/old/signin/";
  const hasAuthError =
    new URLSearchParams(window.location.search).get("error") === "auth";

  if (isLoginScreen && !hasAuthError) {
    window.location.replace(`${omuniWeb}/login`);
    return true;
  }

  return false;
};

if (!preRenderRedirect()) {
  ReactDOM.render(<Root />, document.getElementById("root"));
}
